export default __webpack_public_path__ + "static/media/google-logo.952bbf4d.svg";